import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { RuralLocationViewControllerDelegate, RuralLocationViewController } from "../../Screen/RuralLocation/RuralLocationViewController";
import { TableGenericViewControllerDelegate, TableGenericViewController } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { RuralLocationViewModel } from '../../Screen/RuralLocation/RuralLocationViewModel';
import ProtectedRoute from '../../Components/ProtectedRoute';

export class RuralLocationCoordinator implements IndexCoordinatorDelegate, RuralLocationViewControllerDelegate, TableGenericViewControllerDelegate {
    
    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geplocalizacaorural")
        return (<ProtectedRoute requiredPermissions={['prop.local_rural.*']} path="/:base/localizacao-rural" exact={true} component={(props: any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.local_rural.adicionar',
                    edit: 'prop.local_rural.editar',
                    delete: 'prop.local_rural.excluir',
                }} 
                navigation={props} 
                viewModel={viewModel} 
                delegate={this} 
                title={"Localidade Rural"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new RuralLocationViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.local_rural.adicionar', 'prop.local_rural.editar']} path="/:base/localizacao-rural/cad/:id" exact={true} component={(props: any) => {
            var idPk = props.match.params.id
            return (<RuralLocationViewController navigation={props} viewModel={viewModel} delegate={this} idPrimary={idPk}/>)
        }}/>)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }
    
    add(navigation: any, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geplocalizacaorural") {
            navigation.history.push(`localizacao-rural/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void {
        if(viewModel.getTable() == "geplocalizacaorural") {
            navigation.history.push(`localizacao-rural/cad/${idSelection}`);
            return;
        }
    }

}